import * as React from 'react';
import { FormRenderer } from '@syncfusion/ej2-form-renderer';
import { ComponentBase, applyMixins } from '@syncfusion/ej2-react-base';
/**
 * `FormRenderer` represents the React FormRenderer Component.
 * ```ts
 * <FormRendererComponent schema={schema} />
 * ```
 */
export class FormRendererComponent extends FormRenderer {
    constructor(props) {
        super(props);
        this.initRenderCalled = false;
        this.checkInjectedModules = false;
        this.statelessTemplateProps = null;
        this.templateProps = null;
        this.immediateRender = true;
        this.isReactMock = true;
        this.portals = [];
    }
    render() {
        this.isReactMock = false;
        if (((this.element && !this.initRenderCalled) || this.refreshing) && !this.isReactForeceUpdate) {
            super.render();
            this.initRenderCalled = true;
        }
        else {
            return React.createElement('div', this.getDefaultAttributes(), [].concat(this.props.children, this.portals));
        }
    }
}
applyMixins(FormRendererComponent, [ComponentBase, React.Component]);
